import agilityImg from "../images/afro-solar/our-values/agility.png";
import careImg from "../images/afro-solar/our-values/care.png";
import ethicsImg from "../images/afro-solar/our-values/ethics.png";
import learningImg from "../images/afro-solar/our-values/learning.png";
import safetyImg from "../images/afro-solar/our-values/safety.png";
const valuesInfo = [
  {
    title: "Safety ",
    img: safetyImg,
    description:
      " ​Safety is core value over which no business objective can have a higher priority.​",
  },
  {
    title: "Care",
    img: careImg,
    description:
      "Care for Stakeholders, our Environment, Customers and Stakeholders-  Both existing and potential, our community and our people (our employees and partners).​​",
  },
  {
    title: "Agility",
    img: agilityImg,
    description:
      "Speed, Responsiveness and being Proactive, achieved through Collaboration and Empowering Employees.​​",
  },
  {
    title: "Ethics",
    img: ethicsImg,
    description:
      "Achieve the most admired standards of Ethics, through Integrity and Mutual Trust.​​",
  },
  {
    title: "Learning ",
    img: learningImg,
    description:
      "Building future ready skill sets through learning & training. ​​",
  },
];

const OurValues = () => {
  return (
    <div className="container-fluid pt-7" id="our-values">
      <div className="ms-35 me-35">
        <h2 className="fs-56 lh-64 gilroy-bold text-center pb-7">
          OUR <span className="text-orange-ryb">VALUES</span>
        </h2>
        <div className="row justify-content-center">
          {valuesInfo.map((info) => (
            <div
              key={info.title}
              className="col-12 col-sm-6 col-md-6 col-lg-4 text-center pb-5"
            >
              <div
                className="p-4 h-100 m-2 card-design-3"
                style={{ boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px" }}
              >
                <img src={info.img} alt={info.title} className="img-fluid" />
                <h3 className="fs-18 gilroy-bold pt-4">{info.title}</h3>
                <p className="fs-16">{info.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurValues;
